import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { useToast } from '@/components/ui/toast';

export function useEditPhrase(): {
  mutate: (phrase: string) => void;
  isPending: boolean;
} {
  const qc = useQueryClient();
  const { toast } = useToast();

  const mutation = useMutation({
    mutationFn: (phrase: string): Promise<{ phrase: string }> =>
      pb.send('/api/team/me/phrase', { method: 'POST', body: { phrase } }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['team', 'members'] });
      toast('Frase actualizada', 'success');
    },
    onError: () => toast('Error al actualizar', 'error'),
  });

  return { mutate: mutation.mutate, isPending: mutation.isPending };
}
